import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { CustomButton } from "components/CustomButton";
import { IconInfor } from '../../../../assets/icons_svg/IconInfor';

export function ModalSimplifiedDisabled({ open, handleClose, themeColor, onConfirm, }) {
  const iconColor = themeColor?.visual?.icons?.color || '#74CCD4'

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ backdropFilter: 'blur(2px)', }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 470,
          bgcolor: '#FFFFFF',
          p: '28px 25px',
          borderRadius: '12px',
          boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
          gap: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Box display="flex" alignItems="center" gap="20px" justifyContent="space-between" width='100%' flexDirection='column'>
          <IconInfor sx={{ color: iconColor, fontSize: '80px !important', paddingBottom: '10px' }} />
          <Typography variant="body1" color="#5D5D5D" fontSize="14px" textAlign="center" lineHeight={1.6}>
            Para realizar o 1º acesso, é necessário completar <br />
            o seu cadastro. É rapidinho!!
          </Typography>

        </Box>

        <Box display="flex" justifyContent="center" width="100%" gap='15px'>
          <CustomButton
            size="sm"
            fullWidth
            variant="contained"
            style={{ maxWidth: '174px' }}
            defaultColor="#5CB860"
            onClick={onConfirm}
          >
            Completar cadastro
          </CustomButton>
          <CustomButton
            size="sm"
            fullWidth
            variant="outlined"
            style={{ maxWidth: '174px' }}
            defaultColor="#F05B4F"
            onClick={handleClose}
          >
            Fechar
          </CustomButton>

        </Box>


      </Box>
    </Modal>
  );
}
